import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {IconTrashComponent} from "../../../../icons/icon-trash/icon-trash.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {SocialInterface} from "../../../../../shared/interfaces/global";
import {tap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ModalConfirmationComponent} from "../../../modal-confirmation/modal-confirmation.component";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-linked-account',
  imports: [
    IconTrashComponent,
    TranslateModule
  ],
  templateUrl: './linked-account.component.html',
  styleUrl: './linked-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkedAccountComponent {

  private $http = inject(HttpClient);
  private $modal = inject(MatDialog);
  private $t = inject(TranslateService);
  private $toast = inject(MatSnackBar);

  constructor() {
    this.getSocials().subscribe();
  }


  socialList = signal<SocialInterface[]>([]);
  socialConst = ['yandex', 'vk', 'google'];

  getSocials() {
    return this.$http.get<{ items: SocialInterface[] }>('social-account').pipe(
      tap((res) => {
        this.socialList.set(res.items);
        const backendProviders = this.socialList().map((el) =>
          el.provider.toLowerCase(),
        );

        const missingProviders = this.socialConst.filter(
          (provider) => !backendProviders.includes(provider.toLowerCase()),
        );

        missingProviders.forEach((provider) => {
          this.socialList.update(prev => [
            ...prev,
            {
              provider: provider,
              status: 0,
            }
          ])
        });
      }),
    );
  }

  deleteSocial(id: number, provider: string) {
    this.$modal
      .open(ModalConfirmationComponent, {
        panelClass: ['white'],
        data: {
          title: this.$t.instant('profilePage.deleteSocial', {provider}),
          description: this.$t.instant('profilePage.deleteSocial_description'),
          confirmBtn: this.$t.instant('global.unlink'),
          cancelBtn: this.$t.instant('global.leave'),
          confirmDeletion: true,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.$http
            .delete(`auth/social-account/${id}`, {params: {isSSO: true}})
            .subscribe({
              next: () => {
                this.socialList.set(this.socialList().map((el) => {
                  if (el.id !== id) return el;
                  else return {...el, status: 0};
                }));
              },
              error: () =>
                this.$toast.open(
                  this.$t.instant('profilePage.socialDeleteError'),
                  undefined,
                  {
                    duration: 1500,
                    panelClass: ['error'],
                  },
                ),
            });
        }
      });
  }

  linkSocial(provider: string) {
    this.$http
      .get<{ redirect_url: string }>(`auth/${provider}/binding/login`, {
        params: {
          isSSO: true,
        },
      })
      .subscribe({
        next: (res) => {
          const a = document.createElement('a');
          a.href = res.redirect_url;
          a.click();
        },
        error: () =>
          this.$toast.open('profilePage.socialLinkError', undefined, {
            duration: 1500,
            panelClass: ['error'],
          }),
      });
  }
}
